import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-rowsfeedback',
  templateUrl: './rowsfeedback.component.html',
  styleUrls: ['./rowsfeedback.component.css']
})
export class RowsfeedbackComponent implements OnInit {
  @Input() taFeedback: any = {};
  constructor() { }

  ngOnInit() {
  }

  getSelectedCell(id) {
    if (id && this.taFeedback.cells.length > 0) {
      return this.taFeedback.cells.includes(id);
    }
    return false;
  }

}
